import { KeyValuePair } from '../models/key-value-pair';

export class CopyDocumentDto {
  webDokuId = "";
  documentId = "";
  values: KeyValuePair[] = [];
}
